module.exports = __webpack_public_path__ + "static/media/214x152_4 copy.9e5b807a.png";